/// <amd-module name="TFS/Admin/Views/GitHubConnection/redux/GitHubConnectionReducers" />
import produce from "immer";
import * as Resources from "TFS/Admin/Views/GitHubConnection/Resources";

import { GitHubConnectionActions, GitHubConnectionActionTypes } from "TFS/Admin/Views/GitHubConnection/redux/GitHubConnectionActions";
import { IGitHubConnectionState } from "TFS/Admin/Views/GitHubConnection/Contracts";

export function gitHubConnectionReducer(state: IGitHubConnectionState, action: GitHubConnectionActions): IGitHubConnectionState {
    return produce(state || {}, draft => {
        switch (action.type) {
            case GitHubConnectionActionTypes.InitView: {
                const isToggleEnabled: boolean = action.payload;
                draft.canEdit = true;
                draft.isAadConnected = false;
                draft.isGitHubConnected = false;
                draft.isToggleEnabled = isToggleEnabled;
                break;
            }

            case GitHubConnectionActionTypes.InitialLoadSucceeded: {
                draft.canEdit = action.payload.canLink;
                if (action.payload.collectionId) {
                    draft.collectionId = action.payload.collectionId;
                }

                if (action.payload.inviteSet) {
                    draft.collectionMarkToggle = action.payload.inviteSet;
                }

                if (action.payload.isAadConnected) {
                    draft.isAadConnected = action.payload.isAadConnected;
                }

                if (action.payload.gitHubConnectUrl) {
                    draft.gitHubConnectUrl = action.payload.gitHubConnectUrl;
                }

                if (action.payload.isGitHubConnected) {
                    draft.isGitHubConnected = action.payload.isGitHubConnected;
                }

                if (action.payload.organizationName) {
                    draft.orgName = action.payload.organizationName;
                }

                draft.loading = false;

                break;
            }

            case GitHubConnectionActionTypes.ToggleWasToggled: {
                draft.collectionMarkToggle = action.payload;
                break;
            }

            default:
                return state;
        }
    });
}
